import { useEffect, useState } from "react";
import parse from "html-react-parser";
import DOMPurify from "dompurify";

export default function Privacy() {
  const [content, setContent] = useState("");

  useEffect(() => {
    fetch("/templates/privacy.txt")
      .then((res) => res.text())
      .then((html) => {
        const clean = DOMPurify.sanitize(html, { USE_PROFILES: { html: true } });
        setContent(clean);
      })
      .catch(() => setContent("<p>Unable to load privacy policy.</p>"));
  }, []);

  return (
    <main className="min-h-screen bg-surface px-4 py-12">
      {/* Header */}
      <header className="max-w-4xl mx-auto text-center mb-8">
        <h1 className="text-3xl sm:text-4xl font-bold text-textPrimary mb-2">
          Privacy Policy
        </h1>
        <p className="text-sm text-textSecondary">
          Your privacy is important to us. This policy explains how we collect, use, and protect your personal information.
        </p>
      </header>

      {/* Content */}
      <section className="max-w-4xl mx-auto bg-white rounded-2xl shadow-md p-6 sm:p-8">
        <article className="prose max-w-none
                             prose-headings:text-textPrimary
                             prose-p:text-textSecondary
                             prose-li:text-textSecondary
                             prose-a:text-primary
                             prose-a:hover:text-primary-light">
          {parse(content)}
        </article>
      </section>
    </main>
  );
}
